import React from 'react'

import FieldWrapper from '@/components/Form/FieldWrapper/'
import { Input } from '@chakra-ui/react'

const UncontrolledInput = ({
  label,
  name = label,
  tooltip = label,
  type = 'text',
  placeholder = 'Enter',
  value,
  disabled = false,
  isRequired = true,
  canHighLight = true,
  ref,
  onChange = () => {},
  onBlur = () => {},
  ...rest
}) => {
  return (
    <FieldWrapper name={name} label={label} tooltip={tooltip} isRequired={isRequired} {...rest}>
      <Input
        ref={ref}
        color="blackAlpha.600"
        bg={(value === undefined || value === '') && isRequired && canHighLight ? 'yellow' : 'white'}
        onChange={(e) => onChange(type === 'number' ? +e.target.value : e.target.value)}
        onBlur={onBlur}
        type={type}
        placeholder={placeholder || 'Enter'}
        disabled={disabled}
      />
    </FieldWrapper>
  )
}

export default UncontrolledInput
